export default "__VITE_ASSET__18bd73f4__"